import classnames from 'classnames';
import React__default from 'react';
import { ModalHeading } from './modal_heading.js';
import { useModalState } from './use_modal_state.js';
import '../box/index.js';
import '../button/index.js';
import '../localization/index.js';
import '../stack/index.js';
import { header, headerInner, closeButton } from './modal.css.js';
import { useLocalization } from '../localization/localization.js';
import { Box } from '../box/box.js';
import { Stack } from '../stack/stack.js';
import { Button } from '../button/button.js';

const ModalHeader = ({ title, children, className }) => {
    const closeLabel = useLocalization('close');
    const { setOpen } = useModalState();
    const handleCloseButtonClick = React__default.useCallback((event) => {
        event.preventDefault();
        setOpen(false);
    }, [setOpen]);
    return (React__default.createElement(Box, { padding: "medium", className: classnames(header, className) },
        React__default.createElement(Stack, { justifyContent: "space-between", alignItems: "center", wrap: false },
            React__default.createElement("div", { className: headerInner }, title ? React__default.createElement(ModalHeading, null, title) : children),
            React__default.createElement(Button, { size: "small", iconStart: "small-cross", kind: "subtle", hideLabel: true, onClick: handleCloseButtonClick, className: closeButton }, closeLabel))));
};

export { ModalHeader };
